import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  showCharts: true,
  dateSelection: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  tipoProduto: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
